import PassengerDetailsInput from './PassengerDetailsInput';

export default PassengerDetailsInput;



// WEBPACK FOOTER //
// ./src/ondemand/components/PassengerDetailsInput/index.js